// SERVICES
import Http from '../services/Http';

// private sector
let $http;

export default class STBYLessonRepo {

    static $resource = 'stbylessons';

    constructor($auth){
        $http = new Http($auth);
    }

    show(id){
        return $http.get(STBYLessonRepo.$resource + "/" + id + "?include=school").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    store(data){
        return $http.post(STBYLessonRepo.$resource, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    all(){
        return $http.get(STBYLessonRepo.$resource + "?include=school").then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    paginate(data){
        let query = "include=school";
        return $http.post(STBYLessonRepo.$resource + "/paginate?" + query, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    update(id, data){
        return $http.put(STBYLessonRepo.$resource + "/" + id, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    delete(id){
        return $http.delete(STBYLessonRepo.$resource + "/" + id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    search(data){
        let url = STBYLessonRepo.$resource + '/search?include=school';
        return $http.post(url, data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }


    //CHANGES

    paginateChanges(search){

        return $http.post(STBYLessonRepo.$resource + "/changes/paginate", search).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    showChanges(lesson_id, id){
        return $http.get(STBYLessonRepo.$resource + "/changes/" + lesson_id + "/"+ id).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    approveChanges(item, data){
        return $http.post(STBYLessonRepo.$resource + "/approve/" + item.original.lesson_id + "/" + item.id + "?include=", data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }

    declineChanges(item, data){
        return $http.post(STBYLessonRepo.$resource + "/decline/" + item.original.lesson_id + "/" + item.id + "?include=", data).then((response) => {
            return Promise.resolve(response);
        }).catch((response) =>{
            return Promise.reject(response);
        });
    }
}



// WEBPACK FOOTER //
// ./src/repos/STBYLessonRepo.js